// NPM Imports
import React from "react";

const ChartHeader = props => {
  const { title } = props;
  return (
    <div className="chartheader-wrapper">
      <div className="chartheader-title">{title}</div>
      {/* <div className="chartheader-date">{dateTitle}</div> */}
    </div>
  );
};

export default ChartHeader;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/Charts/ChartHeader/index.js